
<mat-form-field
  *transloco="let t"
  [subscriptSizing]="'dynamic'"
  >
  <mat-label>
    {{ t(options?.label, options?.labelParam) }}
  </mat-label>
  <!-- autocomplete="cc-csc" is a workaround to autocompletion of the field by the browser 
       https://stackoverflow.com/questions/64118290/why-does-chrome-think-that-my-form-is-a-credit-card-form -->
  <input
    type="text"
    matInput
    [autocomplete]="options?.disabledAutocomplete ? 'cc-csc' : ''" 
    [formControl]="control"
    [required]="validators.includes('required')"
    [placeholder]="options?.placeholder"
    [appTrim]="options?.trim"
    [appUppercaseSpace4]="validators.includes('uppercaseSpace4')"
    >
  @if (options?.iconName) {
    <mat-icon matSuffix> {{ options.iconName }}</mat-icon>
  }
  <mat-hint>{{ t(options?.hint) }}</mat-hint>
  @if (options?.charNbrHint && options?.maxLength) {
    <mat-hint align="end">{{control?.value?.length || 0}} / {{options.maxLength}}</mat-hint>
  }
  @if (control.errors) {
    <mat-error>{{ t('formErrors.' + Objectkeys(control.errors)?.[0] ) }}</mat-error>
  }
</mat-form-field>
